import { render } from "./MyAccount.vue?vue&type=template&id=4e60fbc2&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=4e60fbc2&lang=scss"
import "./MyAccount.vue?vue&type=style&index=1&id=4e60fbc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e60fbc2"]])

export default __exports__